
// Types for the application settings
export interface Settings {
  phone: string;
  email: string;
  title: string;
  footerText: string;
  
  whatsappLink: string;
  logoUrl: string | null;
  showVirtualAssistant: boolean;
  
  // Banner settings
  bannerEnabled: boolean;
  bannerText: string;
  bannerBgColor: string;
  bannerTextColor: string;
  bannerLink: string | null;
  bannerLinkText: string | null;
  
  // Dates de mise à jour des pages légales
  cgvUpdatedAt?: string;
  mentionsLegalesUpdatedAt?: string;
  cguUpdatedAt?: string;
  privacyPolicyUpdatedAt?: string;
}

// Default values for settings
export const defaultSettings: Settings = {
  phone: "+33 7 49 40 34 60",
  email: "hello@maisoneridia.com",
  title: "Organisation complète d'évènements",
  footerText: "© 2025 Maison Eridia - Tous droits réservés",
  
  whatsappLink: "https://wa.me/33749403460",
  logoUrl: "/lovable-uploads/maison-eridia-logo.png",
  // Par défaut à false pour éviter l'affichage avant le chargement des vraies valeurs
  showVirtualAssistant: false,
  
  // Banner defaults
  bannerEnabled: false,
  bannerText: "",
  bannerBgColor: "#1a365d",
  bannerTextColor: "#ffffff",
  bannerLink: null,
  bannerLinkText: null,
  
  // Dates par défaut (14 novembre 2025)
  cgvUpdatedAt: "2025-11-14",
  mentionsLegalesUpdatedAt: "2025-11-14",
  cguUpdatedAt: "2025-11-14",
  privacyPolicyUpdatedAt: "2025-11-14",
};

// Interface for the settings context
export interface SettingsContextType {
  settings: Settings | null;
  loading: boolean;
  error: Error | null;
  refreshSettings: () => Promise<Settings | null>;
}
